export default __webpack_public_path__ + "static/media/money.fcfb27ce.png";